import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';
import { BREAKPOINTS } from '@src/styles/config';

export const StyledRewardProgressTracker = styled('div')`
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  .mark-label {
    max-width: 375px;
    background: linear-gradient(
      100.92deg,
      #f48b71 -15.23%,
      #f1414d 42.62%,
      #563efa 99.91%
    );
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  @media (max-width: ${BREAKPOINTS.SMD}px) {
    .title-section-text {
      font-size: 16px;
      line-height: 24px;
    }
    .payment-history-referral-text {
      font-size: 14px !important;
      line-height: 20px !important;
    }
    .description-accumulated-referral-reward-text {
      font-size: 12px !important;
      line-height: 16px !important;
      margin-top: 4px !important;
    }
  }
  .accumulate-current-text {
    strong {
      font-size: 16px !important;
      color: #1c1c1e !important;
    }
  }
`;

export const StyledSliderContainer = styled('div')`
  position: relative;
  padding: ${(props) => props.padding || '32px 24px'};
  background-color: ${COLOR.backgroundDefault};
  border: 1px solid ${COLOR.errorHover};
  border-radius: 16px;
  height: 196px;
  display: flex;
  box-sizing: border-box;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;

export const StyledTopLabels = styled('div')`
  width: 100%;
  position: relative;
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
  height: 20px;
  margin-left: 4px;
  margin-right: 4px;
`;

export const StyledTopLabel = styled('div')`
  position: absolute;
  left: ${(props) => props.left || '0'};
  top: ${(props) => props.top || '0'};
  transform: translateX(-50%);
  font-weight: 400;
  font-size: 14px;
  color: ${COLOR.descriptionUpload};
  white-space: nowrap;
  text-align: center;
  letter-spacing: -0.4px;
`;

export const StyledButtonArrowContainer = styled('div')`
  display: flex;
  gap: 8px;
  align-items: center;
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translateX(-50%);
`;
